import { PublicService } from "./axiosInstance";
import endpoints from "./endpoints";

const marketingApi = {
  async getActiveBanners(placement) {
    const res = await PublicService.get(endpoints.MARKETING_ACTIVE_BANNERS(placement));
    return res?.data?.banners ?? [];
  },
  async submitContact(payload) {
    const res = await PublicService.post(endpoints.CONTACT_REQUEST, payload);
    return res.data;
  },
};

export default marketingApi;
